import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../static/Login.css";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({ email: "", password: "" });

  const navigate = useNavigate();

  // Load saved login from localStorage
  useEffect(() => {
    const savedUser = localStorage.getItem("qauraUser");
    if (savedUser) {
      const user = JSON.parse(savedUser);
      setEmail(user.email);
      setPassword(user.password);
      setRemember(true);
    }
  }, []);

  const validate = () => {
    let valid = true;
    const errs = { email: "", password: "" };

    if (!email.match(/^\S+@\S+\.\S+$/)) {
      errs.email = "Invalid email address";
      valid = false;
    }

    if (password.length < 6) {
      errs.password = "Min 6 characters required";
      valid = false;
    }

    setErrors(errs);
    return valid;
  };

  const handleLogin = (e) => {
    e.preventDefault();
    if (!validate()) return;

    const userData = { email, password };

    // Save Remember Me
    if (remember) {
      localStorage.setItem("qauraUser", JSON.stringify(userData));
    } else {
      localStorage.removeItem("qauraUser");
    }

    // 🔥 Set Login Status
    localStorage.setItem("isLoggedIn", "true");
    localStorage.setItem("userEmail", email);

    // Redirect to courses page
    navigate("/courses");
  };

  return (
    <div className="login-wrapper">
      <div className="shooting-star"></div>

      <div className="login-card">
        <h2 className="login-title">Welcome Back 👋</h2>
        <p className="login-subtitle">Login to QAura Tech Academy</p>

        <form onSubmit={handleLogin} noValidate>

          {/* Email */}
          <div className={`input-group ${errors.email ? "error" : ""}`}>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <label>Email Address</label>
            {errors.email && (
              <span className="error-msg">{errors.email}</span>
            )}
          </div>

          {/* Password */}
          <div className={`input-group ${errors.password ? "error" : ""}`}>
            <input
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <label>Password</label>

            <button
              type="button"
              className="show-pass-btn"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? "HIDE" : "SHOW"}
            </button>

            {errors.password && (
              <span className="error-msg">{errors.password}</span>
            )}
          </div>

          {/* Options */}
          <div className="options">
            <label className="remember">
              <input
                type="checkbox"
                checked={remember}
                onChange={() => setRemember(!remember)}
              />
              Remember Me
            </label>
            <span
              className="forgot"
              onClick={() => navigate("/forgot-password")}
            >
              Forgot Password?
            </span>
          </div>

          {/* Login Button */}
          <button type="submit" className="login-btn">
            Login Now 🚀
          </button>
        </form>

        <p className="signup-link">
          Don't have an account?{" "}
          <span onClick={() => navigate("/register")}>
            Create One
          </span>
        </p>
      </div>
    </div>
  );
}

export default Login;